import { render, staticRenderFns } from "./VideoWatch.vue?vue&type=template&id=1470635c&scoped=true&"
import script from "./VideoWatch.vue?vue&type=script&lang=js&"
export * from "./VideoWatch.vue?vue&type=script&lang=js&"
import style0 from "./VideoWatch.vue?vue&type=style&index=0&id=1470635c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470635c",
  null
  
)

component.options.__file = "VideoWatch.vue"
export default component.exports